import { SlideImageWrapper } from "./styled"
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    autoPlay: true,
    arrows: false,
};
const imageList = [
    {
        src: "https://vcdn1-dulich.vnecdn.net/2021/10/23/49483719-10115915-image-a-11-1634848573982.jpg?w=1200&h=0&q=100&dpr=1&fit=crop&s=9P75xKWJelFaU_aFfPu50g",
        alt: "img 1",
    },
    {
        src: "https://picsum.photos/id/10/900/500",
        alt: "img 2",
    },
    {
        src: "https://picsum.photos/id/100/900/500",
        alt: "img 3",
    },
    {
        src: "https://picsum.photos/id/1000/900/500",
        alt: "img 4",
    },
];

const SliderImage = () => {
    return (
        <SlideImageWrapper>
            <Slider {...settings}>
                {imageList.map((img, key) => (
                    <div key={key} className="slide_item">
                        <img
                            className={`clickable image-item image-slider}`}
                            key={key}
                            src={img.src}
                            alt={img.alt}
                        />
                    </div>
                ))}
            </Slider>
        </SlideImageWrapper>
    )
}

export default SliderImage